// --------------------------------------------------
//  FAQ (preguntas frecuentes)
//  - Acordeón: cada pregunta abre/cierra su respuesta.
//  - Filtro en vivo: oculta preguntas y grupos sin coincidencias.
// --------------------------------------------------

export function initFaq() {

  const root = document.querySelector('[data-faq]');
  if (!root) return;

  // ---------- Acordeón -----------------------------------------------------

  const toggles = root.querySelectorAll('[data-faq-toggle]');

  toggles.forEach((btn) => {

    const item   = btn.closest('[data-faq-item]');
    const answer = item && item.querySelector('[data-faq-answer]');

    if (!item || !answer) return;

    btn.addEventListener('click', () => {

      const isOpen = item.classList.toggle('_open');

      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      answer.hidden = !isOpen;

    });

  });

  // ---------- Filtro en vivo ----------------------------------------------

  const filterRoot = document.querySelector('[data-faq-filter-root]');
  const input      = filterRoot && filterRoot.querySelector('[data-faq-filter]');
  const reset      = filterRoot && filterRoot.querySelector('[data-faq-filter-reset]');
  const empty      = root.querySelector('[data-faq-empty]');
  const groups     = root.querySelectorAll('[data-faq-group]');
  const items      = root.querySelectorAll('[data-faq-item]');

  if (!input || !items.length) return;

  const normalize = (s) => (s || '')
    .toString()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();

  const apply = () => {

    const q = normalize(input.value.trim());

    filterRoot.classList.toggle('_has-value', input.value.length > 0);

    // Sin búsqueda → restaurar todo, cerrar respuestas que abrió el filtro
    if (!q) {

      items.forEach((item) => {
        item.hidden = false;
        item.classList.remove('_match');
      });

      groups.forEach((group) => {
        group.hidden = false;
      });

      if (empty) empty.hidden = true;
      return;

    }

    let anyVisible = false;

    groups.forEach((group) => {

      const groupTitle = normalize(group.dataset.faqGroup || '');
      const groupMatch = groupTitle.includes(q);
      const groupItems = group.querySelectorAll('[data-faq-item]');

      let groupHasMatch = false;

      groupItems.forEach((item) => {

        const haystack = normalize(item.dataset.faqSearch || '');
        const match    = groupMatch || haystack.includes(q);

        item.hidden = !match;
        item.classList.toggle('_match', match);

        if (match) groupHasMatch = true;

      });

      group.hidden = !groupHasMatch;
      if (groupHasMatch) anyVisible = true;

    });

    if (empty) empty.hidden = anyVisible;

  };

  input.addEventListener('input', apply);

  if (reset) {
    reset.addEventListener('click', () => {
      input.value = '';
      apply();
      input.focus();
    });
  }

}
